import { IsGreaterThan } from '@dermloop/utils';
import { IsNumber, IsOptional, Min } from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../base.dto';

export class LesionThicknessDto extends BaseDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  minValue?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @IsGreaterThan<LesionThicknessDto>('minValue', {
    relatedValueNullable: true,
  })
  maxValue?: number;
}

export class CreateLesionThicknessDto
  extends BaseCreateDto
  implements Partial<LesionThicknessDto>
{
  @IsOptional()
  @IsNumber()
  @Min(0)
  minValue?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @IsGreaterThan<CreateLesionThicknessDto>('minValue', {
    relatedValueNullable: true,
  })
  maxValue?: number;
}

export class UpdateLesionThicknessDto
  extends BaseUpdateDto
  implements Partial<LesionThicknessDto>
{
  @IsOptional()
  @IsNumber()
  @Min(0)
  minValue?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @IsGreaterThan<UpdateLesionThicknessDto>('minValue', {
    relatedValueNullable: true,
  })
  maxValue?: number;
}
